// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"a172087f","206":"b17a446b","421":"c5d08fd7","480":"a172087f","704":"5ac325c3"}[chunkId] + ".chunk.css";
};